import { render } from "./CnRules.vue?vue&type=template&id=8141f9ac&scoped=true"
import script from "./CnRules.vue?vue&type=script&scoped=true&lang=js"
export * from "./CnRules.vue?vue&type=script&scoped=true&lang=js"

import "./CnRules.vue?vue&type=style&index=0&id=8141f9ac&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-8141f9ac"

export default script